import * as React from "react";
import { Typography } from "@mui/material";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useXoraiaValue } from "../../hooks/useXoraia";
import { TUseXElement, useXElement } from "../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../hooks/useSelectedElement";
import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../lib/clickHandler";
import {
  XTextProps,
  IXTextProps,
} from "../../utils/interfaces/Elements/XText.interfaces";

import { isEqual } from "lodash";

import { generateSide } from "../../lib/generateSide";
import { XElementConfig } from "../../utils/interfaces/Elements/XElement.interfaces";
import { generateBorder } from "../../lib/generateBorder";
import { generateRadius } from "../../lib/generateRadius";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XText: React.FC<XTextProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { env } = useXoraiaValue();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXTextProps>>(config.index);

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXTextProps>(
      value as any,
      breakpoint
    );

    const devProps = {
      id: config.index,
      onClick: (e: any) => clickHandler(e, setSelectedElement, config.index),
    };

    const {
      text = "TEXTE",
      padding,
      margin,
      color,
      bgColor,
      border,
      borderRadius,
      tag = "body1",
      ...sx
    } = valueAtBreakPoint;

    return (
      <Typography
        {...(env === "dev" && devProps)}
        variant={tag}
        sx={{
          ...sx,
          boxSizing: "border-box",
          padding: generateSide("padding", padding),
          margin: generateSide("margin", margin),
          border: generateBorder(border),
          borderRadius: generateRadius(borderRadius),
          color: color,
          bgcolor: bgColor,
        }}
      >
        {text}
      </Typography>
    );
  },
  compareProps
);

export default XText;
